module.exports = __webpack_public_path__ + "18deb832d2e4d08e4e1827680ba16aff.png";